import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { RmsMaximumCapacityOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/rms-maximum-capacity.provider';

@Injectable()
export class RmsHandleMaximumCapacityOpenPlatformService implements OnFieldChanged {
  constructor() {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    const quantityField = form.config.find(
      (control) => control.name === SpecFieldNames.QUANTITY,
    ) as FieldInputNumberConfig;
    if (quantityField.max instanceof RmsMaximumCapacityOpenPlatformProvider.RmsMaximumCapacityBase) {
      quantityField.max.unitSubject.next();
    }
    if (quantityField.message instanceof RmsMaximumCapacityOpenPlatformProvider.RmsMaximumCapacityBase) {
      quantityField.message.unitSubject.next();
    }
  }
}
